import React from 'react'

export default function Apply() {
  return (
    <div>
      <h1>Welcome to apply page</h1>
    </div>
  )
}
